import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, useMemo } from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Slide,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentUserEmpCode,
  selectCurrentUser,
  selectNotificationNewsId,
  setGnnStatus,
  setNotificationNewsId,
} from '../../Auth/authSlice';

import NewsCarousel from './NewsCarousel';
import SearchAndFilter from './SearchAndFilter';
import NewsList from './NewsList';
import {
  useGetNewNonTechnicalOpeningsQuery,
  useGetNewOpeningsQuery,
  useGetNewTechnicalOpeningsQuery,
  useGetTopNewsQuery,
  useGetTrendingNewsQuery,
} from '../gnnApiSlice';
import PostNewsDialog from './PostNewsDialog';
import Birthday from './Birthday';
import WorkAnniversary from './WorkAnniversary';
import './FlipCard.css';
import storyImg from './story.png';
import trendingImg from './trendingImg.png';
import WorkAnniversaryIcon from '../../../assets/Gifs/workAnniversaryIcon.gif';
import CakeIcon from '../../../assets/Gifs/cake.png';
import NewJoineesIcon from '../../../assets/Gifs/NewJoinees.gif';
import dev from '../../../assets/developers/dev.png';
import SwipeableGrid from './SwipeableGrid.jsx';
import Confetti from 'react-confetti';
import NewsJoinees from './NewJoinees';
import { variants } from '../../../variants/variants';
import CarouselComponent from './carousel';
import { Add, Article, Close, EditNote, Event, Feed, PhotoCamera, Work, WorkHistory } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import NewsListDesktop from './NewsListDesktop';
import UserAvatar from '../../../common/UserAvatar.jsx';
import { useFetchProfileQuery } from '../../Profile/profileApiSlice.js';
import Stories from './Stories.jsx';
import GnnStories from './GnnStories.jsx';
import { resetPostNews, setNewsId } from '../gnnSlice.js';
import NewsCardList from './NewsCardList.jsx';
import {} from '@mui/material';
import { VariableSizeList } from 'react-window';
import { useNavigate } from 'react-router-dom';
import {
  useLazyGetAllNewsQuery,
  useDeleteNewsMutation,
  useGetNewsByIdQuery,
  useLazyGetNewsByIdQuery,
} from '../gnnApiSlice';
import {} from '../../Auth/authSlice';
import LikesModal from './LikesModal';
import NewsRow from './NewsRow';
import useSocket from '../../../hooks/sockets/useSocket';
import { useExpanded } from '../contexts/ExpandedContext';
import InfiniteLoader from 'react-window-infinite-loader';
import { empty } from '../../Gift/assets/index';
import { Newspaper } from '@mui/icons-material';
import NewsComments from './NewsComments';
import CustomDialogBox from '../../../common/CustomDialogBox';
import NewsDetailsNavbar from './NewsDetailsNavbar';
import RowVirtualizerDynamic from './tanstack/RowVirtualizerDynamic';
import { useVirtualizer } from '@tanstack/react-virtual';

const GnnTab = () => {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedRegions, setSelectedRegions] = useState('');
  const dispatch = useDispatch();
  const empCode = useSelector(selectCurrentUserEmpCode);
  const [openDialog, setOpenDialog] = useState(false);
  const [newsPosted, setNewsPosted] = useState(false);
  const { data: trendingNews, isLoading: isTrendingLoading, isError: isTrendingError } = useGetTrendingNewsQuery();
  const { data: topNews, isLoading: isTopNewsLoading, isError: isTopError } = useGetTopNewsQuery();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isBelow364px = useMediaQuery('(max-width:364px)');
  const { newsData, setNewsData } = useExpanded();
  const user = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const [deleteNews] = useDeleteNewsMutation();
  const [likesModalOpen, setLikesModalOpen] = useState(false);
  const [currentLikes, setCurrentLikes] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false); // State to control dialog visibility
  const [selectedNewsId, setSelectedNewsId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isNextPageLoading, setIsNextPageLoading] = useState(false);
  const { socket } = useSocket();
  const [itemSizes, setItemSizes] = useState({});
  const [getNewsById, { isFetching }] = useLazyGetNewsByIdQuery();
  // const { expandedItems, listRef } = useExpanded();
  const [getAllNews, { data }] = useLazyGetAllNewsQuery();
  const [itemCountTotal, setItemCountTotal] = useState(0);
  const parentRef = useRef(null);
  const virtualizer = useVirtualizer({
    count: newsData?.length === 1 ? 2 : newsData?.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 200,
    overscan: 5,
  });
  const notificationNewsId = useSelector(selectNotificationNewsId);

  useEffect(() => {
    if (newsData.length > 1 && newsData[1]?._id) {
      dispatch(setNewsId(newsData[1]._id));
      navigate(`/home/announcement/gnn/${newsData[1]._id}`);
    }
  }, [newsData]);
  console.log('selectedNewsId', newsData[1]?._id);
  const handleRefresh = () => {
    setPage(1);
    setNewsData(['buffer']);
    setHasMore(true);
    setItemCountTotal(0);
  };

  useEffect(() => {
    handleRefresh();
  }, [selectedCategory]);

  useEffect(() => {
    if (newsData.length > 1 || loading) {
      dispatch(setNewsId(newsData[1]?._id));
      navigate(`/home/announcement/gnn/${newsData[1]?._id}`);
      console.log('Resetting news data due to filter change');
      handleRefresh();
    }
  }, [selectedCategory, searchTerm, newsPosted]);

  // useEffect(()=>{
  //     function handleNewsId(event) {
  //       console.log('notification', event?.data);
  //             const message = JSON.parse(event?.data);
  //             // console.log("type of message", typeof message.data?.newsId);
  //             console.log("type of message", message);
  //             if (message?.type === "NotificationData") {
  //               console.log('i am here in notification message',typeof message?.data?.newsId,message?.data?.newsId)
  //               // setNewsId(message.data?.newsId);
  //               handleCardClick(message?.data?.newsId)
  //               // dispatch(setNotificationNewsId(message.data?.newsId))
  //             }
  //           }
  //       document.addEventListener("message",handleNewsId);
  //       window['ReactNativeWebView'] &&
  //       window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'newsId', value: "received" }));
  //       // console.log("newsId", newsId);
  //       // dispatch(setNotificationNewsId(newsId))
  //       return () => {
  //         document.removeEventListener("message", handleNewsId);
  //       };
  //     },[])

  // console.log("notificationNewsId", notificationNewsId);
  // useEffect(() => {
  //   if (notificationNewsId) {
  //     handleCardClick(notificationNewsId);
  //     // dispatch(setNotificationNewsId(null));
  //   }
  // },[notificationNewsId]);

  // useEffect(() => {
  //   if (!loading && newsData.length === 1 && hasMore) {
  //     loadNextPage(); // Load the first page of data when component mounts or when newsposted changes
  //   }
  // }, [newsPosted, loading, newsData.length, hasMore]);

  useEffect(() => {
    const handleNewCount = (message) => {
      setNewsData((prevNews) =>
        prevNews?.map((news) =>
          news?._id === message._id
            ? {
                ...news,
                likes: message.likes,
                comments: message.comments,
                viewCount: message.viewCount,
                top5News: message.top5News,
              }
            : news
        )
      );
    };

    socket.on('new-count', handleNewCount);

    return () => {
      socket.off('new-count', handleNewCount);
    };
  }, [socket]);

  useLayoutEffect(() => {
    dispatch(setGnnStatus(false));
  }, [dispatch]);
  const handleLikesClick = async (event, likes, newsId) => {
    event.stopPropagation();
    setLikesModalOpen(true);
    const newData1 = await getNewsById(newsId).unwrap();

    const newData = newData1[0];
    setNewsData((prevNews) =>
      prevNews?.map((news) =>
        news?._id === newData._id
          ? {
              ...news,
              likes: newData.likes,
              comments: newData.comments,
              viewCount: newData.viewCount,
              top5News: newData.top5News,
            }
          : news
      )
    );
    setCurrentLikes(newData.likes);
  };

  //   const handlePostNews = (formData) => {
  //     // console.log('Posting news:', formData);
  //     setOpenDialog(false);
  //   };

  const handleCardClick = (id) => {
    navigate(`/home/announcement/gnn/${id}`);
    // setSelectedNewsId(id);
    // setDialogOpen(true);
  };
  //   const handleCloseDialog = () => {
  //     setDialogOpen(false);
  //   };
  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedNews([]);
    setIsEdit(false);
    dispatch(resetPostNews());
  };

  const handleEditClick = (event, news) => {
    event.stopPropagation();
    setSelectedNews(news);
    setEditDialogOpen(true);
    setIsEdit(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    dispatch(resetPostNews());
  };
  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    dispatch(resetPostNews());
  };

  const handleDeleteClick = async (event, id) => {
    event.stopPropagation();
    try {
      await deleteNews(id).unwrap();
      const deletedIndex = newsData.findIndex((news) => news._id === id);

      setNewsData((prevData) => prevData.filter((news) => news._id !== id));
    } catch (error) {
      console.error('Error deleting news:', error);
    }
  };

  const loadNextPage = useCallback(async () => {
    console.log('news data called 2nd', page);
    setLoading(true);

    if (isNextPageLoading || !hasMore) return;
    setIsNextPageLoading(true);
    try {
      const response = await getAllNews({
        category: selectedCategory,
        page,
        userEmpCode: empCode,
        searchTerm: searchTerm || '',
        pageSize: 4,
      }).unwrap();
      console.log('news data', response.data);
      // setNewsData((prevData) => [...prevData, ...response.data]);
      setItemCountTotal((prev) => prev + response.data.length);
      // setItemCountTotal(response.totalCount);

      if (response.data.length > 0) {
        setNewsData((prevData) => [...prevData, ...response.data]);
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false); // No more data to load
      }
      // if (response.data.length < 4) {
      //   setHasMore(false);
      // } else {
      //   setPage((prevPage) => prevPage + 1);
      // }
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setIsNextPageLoading(false);
      setLoading(false);
    }
  }, [page, selectedCategory, newsPosted, empCode, searchTerm, isNextPageLoading, hasMore, currentLikes]);

  useEffect(() => {
    const [lastItem] = [...virtualizer.getVirtualItems()].reverse();
    console.log('last item', lastItem);
    if (!lastItem) {
      return;
    }

    if (lastItem.index >= itemCountTotal && hasMore && !isNextPageLoading) {
      loadNextPage(); // Load more data as we scroll to the bottom
    }
  }, [
    hasMore,
    isNextPageLoading,
    virtualizer
      .getVirtualItems()
      .map((item) => item.index)
      .join(','),
    loadNextPage,
    selectedCategory,
  ]);

  useEffect(() => {
    // Handle messages from React Native
    const handleMessage = (event) => {
      if (event.data === 'closeDialog' && (dialogOpen || editDialogOpen)) {
        handleCloseDialog();
        handleEditDialogClose();
      } else {
        try {
          let message = event.data?.split('-');
          if (message[0] === 'news') {
            handleCardClick(message[1]);
            window['ReactNativeWebView'] && window['ReactNativeWebView']?.postMessage(JSON.stringify(message));
          }
        } catch (err) {}
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dialogOpen, editDialogOpen, handleEditDialogClose, handleCloseDialog]);

  const handleMediaLoad = (index) => {
    virtualizer.measureElement(virtualizer.getVirtualItems()[index]);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handlePostNews = (formData) => {
    // console.log('Posting news:', formData);
    setOpenDialog(false);
  };

  const handleCountryChange = (event, newValue) => {
    setSelectedCountry(newValue);
    setSelectedRegions('');
  };
  // console.log(selectedCountry, 'selectedCountry');

  const handleRegionChange = (event, newValue) => {
    setSelectedRegions(newValue);
  };
  if (isTrendingError) {
    return <p>Error: Failed to fetch news</p>;
  }

  return (
    <Stack sx={{ flex: 1 }}>
      <NewsCardList
        rows={newsData}
        //   children={children}
        handleCardClick={handleCardClick}
        handleDeleteClick={handleDeleteClick}
        handleLikesClick={handleLikesClick}
        handleEditClick={handleEditClick}
        virtualizer={virtualizer}
        parentRef={parentRef}
        showLoader={loading && page === 1}
        showDefault={newsData?.length === 1 && !loading}
        showloading={isNextPageLoading && hasMore}
        showEnd={!hasMore}
        handleMediaLoad={handleMediaLoad} // Prop to handle media loading
        handleRefresh={handleRefresh}
      >
        <Box style={{ width: '100%', height: 'auto' }}>
          <Box
            display="flex"
            flexDirection="column"
            // alignItems="center"
            //   p={1}
            bgcolor="white"
            // #f3f2ef
            // borderRadius={2}
            // boxShadow={1}
            sx={{
              mt: 1,
              // mb: 1,
              border: 1, // applies a general border to see the corner styles
              borderColor: 'divider',
              borderLeft: 'none', // remove left border to highlight bottom left radius
              borderRight: 'none', // remove right border to show the effect clearly
              borderTop: 'none', // remove right border to show the effect clearly
            }}
          >
            <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/* <Avatar src={user && user?.employeePhotoPath} alt="Profile" /> */}
              <Box
                //   ml={2}
                //   flexGrow={1}
                onClick={handleOpenDialog}
                sx={{
                  textTransform: 'none',
                  justifyContent: 'flex-start',
                  width: '100%',
                  borderRadius: 30,
                  paddingLeft: 2,
                  paddingTop: 1,
                  paddingBottom: 1,
                  border: 1,
                  borderColor: 'darkgrey',
                  borderRadius: '20px',
                }}
              >
                <Tooltip title="Post News">
                  <Typography color="textSecondary" sx={{ fontSize: '12px', mt: 0.2 }}>
                    Start a post, try writing GNews
                  </Typography>
                </Tooltip>
                {/* </Button> */}
              </Box>
            </Grid>

            <Box display="flex" sx={{ mt: 1, justifyContent: 'space-between' }}>
              <IconButton onClick={handleOpenDialog}>
                <PhotoCamera sx={{ color: 'grey' }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  Media
                </Typography>
              </IconButton>
              <IconButton onClick={handleOpenDialog}>
                <EditNote sx={{ color: 'grey' }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  Write Article
                </Typography>
              </IconButton>
              <IconButton onClick={handleOpenDialog}>
                <Feed sx={{ color: 'grey' }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  News
                </Typography>
              </IconButton>
            </Box>
            <SearchAndFilter
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
              selectedCategory={selectedCategory}
              onCategoryChange={handleCategoryChange}
              selectedCountry={selectedCountry}
              selectedRegions={selectedRegions}
              handleCountryChange={handleCountryChange}
              handleRegionChange={handleRegionChange}
            />
            {isEdit ? (
              <PostNewsDialog
                open={editDialogOpen}
                onClose={handleCloseEditDialog}
                newsData={selectedNews}
                isEdit={isEdit}
                setNewsPosted={setNewsPosted}
              />
            ) : (
              <PostNewsDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onSubmit={handlePostNews}
                newsPosted={newsPosted}
                setNewsPosted={setNewsPosted}
                setOpenDialog={setOpenDialog}
              />
            )}
          </Box>
        </Box>
      </NewsCardList>
    </Stack>
  );
};

export default GnnTab;
